export default __webpack_public_path__ + "static/media/ASTR.74697cc0.png";